import React, { useEffect } from "react"
import { type CopyFmpProjectMutation, useCopyFmpProjectMutation } from "../../../type-and-hooks"

interface useCopyMutationInterface {
  fmpId: number | undefined
  userId: number | undefined
  projectName: string | undefined
}
interface returnTypeInterface {
  error: string | null
  data?: CopyFmpProjectMutation | undefined | null
  loading: boolean
  copyFunction: ({ fmpId, userId, projectName }: useCopyMutationInterface) => Promise<returnTypeInterface>
}
export const useCopyMutation = (): returnTypeInterface => {
  const [copyFmpProject, { data, loading, error }] = useCopyFmpProjectMutation()
  const [copyData, setCopyData] = React.useState<CopyFmpProjectMutation | null | undefined>()

  useEffect(() => {
    setCopyData(data)
  }, [data])

  const copyFMP = async ({ fmpId, userId, projectName }: useCopyMutationInterface): Promise<returnTypeInterface> => {
    if (!fmpId || !userId || !projectName) {
      return {
        error: "Please provide all the required fields",
        data: null,
        loading: false,
        copyFunction: copyFMP
      }
    }

    try {
      await copyFmpProject({
        variables: {
          copyFmpProjectId: fmpId,
          userId,
          projectName
        }
      })
      return {
        error: null,
        data: copyData,
        loading: false,
        copyFunction: copyFMP
      }
    } catch (error: any) {
      return {
        error: error.message,
        data: null,
        loading: false,
        copyFunction: copyFMP
      }
    }
  }

  return {
    copyFunction: copyFMP,
    data: copyData,
    loading,
    error: (error?.graphQLErrors?.[0] as unknown as string)?.toString() ?? null
  }
}
